import { _ as __read } from '../../_tslib-7a01aab4.js';
import { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import '../core/enums/GameSpecificTypes.js';
import '../core/enums/MaxPayoutDataTypes.js';
import '../core/enums/Chat.js';
import '../core/enums/GameModes.js';
import '../core/enums/IconTypes.js';
import '../core/enums/BetStatus.js';
import '../core/enums/PopupTypes.js';
import '../core/enums/ApiVersion.js';
import '../core/enums/RoundStatus.js';
import '../core/enums/FreeBetsStatus.js';
import '../core/enums/SocketEvents.js';
import '../core/enums/TranslationKeys.js';
import '../core/enums/TimeoutMaxValue.js';
import '../core/enums/ApiServiceTypes.js';
import '../core/enums/EnvironmentTypes.js';
import '../core/enums/DefaultQueryValues.js';
import '../core/enums/FreeBetWinningType.js';
import '../core/enums/DefaultQueryParams.js';
import '../core/enums/BetHistoryFilterTypes.js';
import '../core/enums/GameThemeTypes.js';
import '../core/enums/RequestStatus.js';
import '../core/enums/FetchDefaultPaths.js';
import '../core/enums/ResponseCodes.js';
import { isMobile } from '../core/helpers/isMobile.js';
import { Q as userSettingsStore, _ as loadingStore } from '../../validateBalanceOnBet-af4f4a9b.js';
import '../core/store/chatStore.js';
import '../core/store/wageringStore.js';
import '../core/store/roundInfoStore.js';
import '../core/store/userCountStore.js';
import '../core/store/gameResultStore.js';
import '../core/store/resultHashStore.js';
import '../core/store/userWinBetsStore.js';
import '../core/store/notificationStore.js';
import '../core/store/selectedResultInfoStore.js';
import '../core/store/forCrashGame/inputValidationStore.js';
import '../core/store/forCrashGame/totalBetStore.js';
import '../core/store/forCrashGame/resultReportStore.js';
import '../core/store/forCrashGame/gameStore.js';
import '../core/services/liveConnection/types.js';
import 'axios';
import '../core/services/sound/types.js';
import '../core/services/sound/SoundService.js';
import '../core/services/sound/defaultSounds.js';
import '../core/services/api/types.js';
import '../core/services/ApiServices.js';
import '../../momentFormat-e9197995.js';
import '../core/polyfill.js';
import 'mobx';
import '../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../core/enums/BogLineGameConfig.js';
import '../core/helpers/parseQuery.js';
import '../core/enums/StatisticsSortingTypes.js';
import '../core/services/api/BaseApiService.js';
import '../core/helpers/deepCopy.js';
import '../../table-line/t_types/enums/BetResponseCode.js';
import '../../table-line/t_types/enums/BetErrorMessages.js';
import '../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../table-line/t_types/enums/FreeChipTypes.js';
import '../../table-line/t_types/enums/PopupTypes.js';
import '../core/helpers/formatDate.js';
import '../core/enums/bogGameNames.js';
import '../core/helpers/updateHalfBets.js';
import 'howler';
import '../../_commonjsHelpers-17aad09c.js';

var useUpdateEffect = function (func, dep) {
    var ref = useRef(false);
    useEffect(function () {
        if (ref.current)
            func();
        else
            ref.current = true;
    }, dep);
};
var useSoundWatcher = function (roomName, soundsByRoom) {
    var soundService = userSettingsStore.soundService, isMusicOn = userSettingsStore.isMusicOn, isSoundOn = userSettingsStore.isSoundOn;
    var gameLoading = loadingStore.gameLoading;
    var _a = __read(useState(false), 2), isClickedDocument = _a[0], setIsClickedDocument = _a[1];
    var toUpperCaseRoom = useMemo(function () {
        if (roomName) {
            return roomName.split(' ').join('').toUpperCase();
        }
        return null;
    }, [roomName]);
    var handleDocumentClick = useCallback(function () {
        setIsClickedDocument(true);
        document.removeEventListener('click', handleDocumentClick);
    }, []);
    useEffect(function () {
        document.addEventListener('click', handleDocumentClick);
        return function () {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);
    var playMusic = function () {
        if (isMusicOn === true && isClickedDocument && !gameLoading) {
            setIsClickedDocument(true);
        }
        if (!isSoundOn) {
            soundService.muteSounds(true);
        }
        document.removeEventListener('click', playMusic);
    };
    useUpdateEffect(function () {
        soundService.muteMusic(true);
        soundService.muteSounds(true);
        if (!gameLoading) {
            soundService.muteMusic(!isMusicOn);
            soundService.muteSounds(!isSoundOn);
            soundService.playMusic();
        }
    }, [gameLoading]);
    useUpdateEffect(function () {
        if (!gameLoading) {
            soundService.playMusic();
            if (roomName) {
                soundService.play(soundsByRoom[toUpperCaseRoom]);
            }
            document.addEventListener('click', playMusic);
        }
        if (isSoundOn) {
            soundService.muteSounds(!isSoundOn);
        }
    }, [gameLoading, isMusicOn, isClickedDocument, roomName, toUpperCaseRoom, soundsByRoom]);
    var muteMusicAndSounds = useCallback(function () {
        soundService.muteMusic(document.hidden ? true : !isMusicOn);
        soundService.muteSounds(document.hidden ? true : !isSoundOn);
    }, []);
    useEffect(function () {
        if (isMobile()) {
            document.addEventListener('visibilitychange', muteMusicAndSounds);
            return function () {
                document.removeEventListener('visibilitychange', muteMusicAndSounds);
            };
        }
    }, []);
};

export { useSoundWatcher };
